import { interceptor } from '@/common/utils/interceptor';
import * as Constants from '@/common/utils/constants';

export default [
  // 体检报告
  {
    path: '/physical/report',
    component: () => import('@/pages/physical/report'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    },
    children: [
      // 体检报告详情
      {
        path: 'detail',
        component: () => import('@/pages/physical/report-detail'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
        }
      }
    ]
  }
];
